import React, { useMemo } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Collapse,
  Space,
  Button,
  Tooltip
} from '@lockerpm/design';

import {
} from "@ant-design/icons";

import itemsComponents from "../../../../../components/items";

const BoxData = (props) => {
  const { TextCopy } = itemsComponents;
  const { t } = useTranslation();
  const isReadOnly = useSelector((state) => state.project.isReadOnly)

  const {
    loading = false,
    className = '',
    data = [],
    params = {},
    onUpdate = () => {},
  } = props;

  const boxData = useMemo(() => {
    return data.map((d, index) => ({ ...d, stt: index + 1 + (params.page - 1) * params.size }))
  }, [data])

  return (
    <Collapse
      className={className}
      bordered={true}
      expandIconPosition="end"
      size="small"
      collapsible='icon'
      loading={loading}
    >
      {
        boxData.map((record) => <Collapse.Panel
          key={record.id}
          header={<div
            className="flex align-items justify-between"
          >
            <div className="flex align-items">
              <TextCopy
                value={record.leakedSecret.key}
              />
            </div>
            {
              !isReadOnly && <Space size={[8, 8]}>
                <Tooltip
                  title={t('leaked_secrets.tooltip.store_in')}
                >
                  <Button
                    icon={<PrinterOutlined />}
                    type={'text'}
                    onClick={() => onUpdate(record)}
                  ></Button>
                </Tooltip>
              </Space>
            }
          </div>}
        >
          <div className="flex items-center mb-2">
            <p className="font-semibold mr-2">{t('secret.value')}:</p>
            <TextCopy
              show={false}
              align={'between'}
              value={record.leakedSecret.value}
            />
          </div>
          <div className="flex items-center mb-2">
            <p className="font-semibold mr-2">{t('leaked_secrets.location')}:</p>
            <TextCopy
              value={record.leakedSecret.location}
            />
          </div>
          <div className="flex items-center">
            <p className="font-semibold mr-2">{t('leaked_secrets.line_in_code')}:</p>
            <TextCopy
              value={record.leakedSecret.line_in_code}
            />
          </div>
        </Collapse.Panel>)
      }
    </Collapse>
  );
}

export default BoxData;
